<template>
  <div>
    <v-menu
      ref="date_menu_flag"
      v-model="date_menu_flag"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="dateRangeText"
          readonly
          clearable
          :label="$t('billing_page.filters.f1')"
          append-icon="mdi-calendar"
          v-bind="attrs"
          @click:append="date_menu_flag = !date_menu_flag"
          v-on="on"
          class="email-datepicker rocista-date-picker"
        ></v-text-field>
      </template>
      <v-date-picker
        locale="hr"
        v-model="date_range"
        range
        no-title
        :pickerDate.sync="pickerDate"
      >
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      date_menu_flag: false,
      date_range: [],
      pickerDate: null,
      first_time: true,
    };
  },
  computed: {
    /**
     * computed value that handles change of value for display style to user.
     */
    dateRangeText: {
      get() {
        var ret_date_string = [];
        this.date_range = this.date_range.sort(
          (a, b) => new Date(a) - new Date(b)
        );
        this.date_range.forEach((p) => {
          ret_date_string.push(moment(p).format("l"));
        });
        if (this.first_time) {
          this.first_time = false;
        } else {
          this.emitToParent();
        }

        return ret_date_string.join(" ~ ");
      },
      set(new_val) {
        // console.log(new_val)
        if (new_val == null) {
          this.date_range = [];
        }
      },
    },
  },
  methods: {
    /**
     * Method that emits to parrent according to format for MS Graph appropriate.
     */
    emitToParent() {
      console.log("the value has changed.", this.date_range);
      let filter_date = "";
      if (this.date_range.length == 1) {
        filter_date =
          "receivedDateTime gt " +
          new Date(
            moment(this.date_range[0]).startOf("day").format()
          ).toISOString() +
          " AND receivedDateTime lt " +
          new Date(
            moment(this.date_range[0]).endOf("day").format()
          ).toISOString();
      } else if (this.date_range.length == 2) {
        filter_date =
          "receivedDateTime gt " +
          new Date(
            moment(this.date_range[0]).startOf("day").format()
          ).toISOString() +
          " AND receivedDateTime lt " +
          new Date(
            moment(this.date_range[1]).endOf("day").format()
          ).toISOString();
      }
      this.$emit("dateChange", {date_string : filter_date, range : this.date_range});
    },
  },
};
</script>

<style></style>
